import { render, staticRenderFns } from "./SettingPlanAddPad.vue?vue&type=template&id=70b320ec&scoped=true&"
import script from "./SettingPlanAddPad.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAddPad.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAddPad.vue?vue&type=style&index=0&id=70b320ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b320ec",
  null
  
)

export default component.exports